import { PROJECT_TYPE, PROJECT_STATUS, QUOTE_TYPE } from "../../../util/enums";

export const getProjectType = ({ type, status, projectQuoteType }) => {

    let isCurrent = type == PROJECT_TYPE.PROJECT && (projectQuoteType == QUOTE_TYPE.NOQUOTE || (projectQuoteType == QUOTE_TYPE.QUOTE && status == PROJECT_STATUS.IN_PROGRESS)) && getActiveProjects(status);
    let isQuote = (type == PROJECT_TYPE.TENDER || (projectQuoteType == QUOTE_TYPE.QUOTE && status != PROJECT_STATUS.IN_PROGRESS)) && getActiveProjects(status);
    let isDLP = status == PROJECT_STATUS.DLP;
    let isCompleted = status == PROJECT_STATUS.COMPLETED;
    let isArchived = [PROJECT_STATUS.LOST, PROJECT_STATUS.CANCELLED, PROJECT_STATUS.ARCHIVED].includes(status);

    return { isCurrent, isQuote, isDLP, isCompleted, isArchived, isVariation: projectQuoteType == QUOTE_TYPE.QUOTE ? true : false }
}

export const getActiveProjects = (status) => {
    return !([PROJECT_STATUS.DLP, PROJECT_STATUS.COMPLETED, PROJECT_STATUS.ARCHIVED, PROJECT_STATUS.CANCELLED, PROJECT_STATUS.LOST].includes(status))
}